<template>
  <div class="pricing-plans-container-parent">
    <section class="pricing-plans-container-child"  >
      <PricingPlans
        :planName="$t('plans.basic-title')"
        :togglePrice="togglePrice"
      />

      <div class="pricing-plans-pro-parent">
        <PricingPlans
          :planName="$t('plans.pro-title')"
          :togglePrice="togglePrice"
        />
      </div>

      <PricingPlans
        :planName="$t('plans.master-title')"
        :togglePrice="togglePrice"
      />
    </section>
  </div>
</template>
<script>

import PricingPlans from '@/components/PricingPlans.vue'

export default {
  name: 'HomePlansContainer',
  components: {
    PricingPlans
  },
  props: {
    togglePrice: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">

</style>
